



















































































import Vue from 'vue';
import ApiSearch from '@/components/apiSearch/components/ApiSearchPage.vue';
import { ColumnType } from '@/components/apiSearch/models/ApiSearch';
import MoneyDisplay from '@/components/MoneyDisplay.vue';
import TransactionItemDimension from './TransactionItemDimension.vue';
import { FilteringModel } from '@/services/filtering';
import { Grid } from '@progress/kendo-vue-grid';
import dayjs from 'dayjs';
import basket, { ReconBasketItem, ReconBasketStore } from '../services/ReconBasketStore';

interface Data {
  url: string;
  basket: ReconBasketStore;
}

interface Methods {
  toBasketItem(item: any): ReconBasketItem;
  basketReason(item: any): string;
  basketTooltip(item: any): string;
  matchedLabel(item: any): string;
  addToBasket(item: any): void;
  rowRender(h: any, trElement: any, defaultSlots: any, props: any): any;
}

interface Computed {
  columns: any[];
}

interface Props {
  transaction: any;
  extraFilter: FilteringModel;
  showSpecDims: boolean;
}

type Transaction = any;

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    transaction: { type: Object as () => Transaction },
    extraFilter: { type: Object as () => FilteringModel },
    // A böngésző spec.dim oszlop-kapcsolója a tétel-listára is érvényes (fej + tétel együtt vált)
    showSpecDims: { type: Boolean, default: true },
  },

  components: {
    TransactionItemDimension,
    ApiSearch,
    MoneyDisplay,
    Grid
  },

  data() {
    return {
      url: "",
      basket,
    }
  },

  beforeMount() {
    this.url = `general-ledger-transaction/transactions/${this.$props.transaction.id}/items`;
  },

  methods: {
    // A tétel-lista sora (TransactionItemDTO) → a pontozás-szerkesztő sor-alakja (BookReconItemDTO);
    // a gazdasági esemény a fejről jön, az előjel 'T'/'K' → bool
    toBasketItem(item) {
      return {
        id: item.id,
        trans: item.trans,
        accno: item.accNo,
        total: Number(item.total || 0),
        accDate: dayjs(item.accDate).format('YYYY-MM-DD'),
        accEvent: this.transaction.accEvent,
        accSign: item.accSign === 'T',
        partnerName: item.partner,
        remark: item.remark,
        reconHead: item.reconHead,
        reconHead2: item.reconHead2,
      };
    },

    basketReason(item) {
      return this.basket.rejectReason(
        this.toBasketItem(item),
        this.transaction.status,
        !!this.transaction.storno,
        !!this.transaction.isOnlyElabe,
      );
    },

    basketTooltip(item) {
      if (this.basket.has(item.id)) {
        return 'Kivétel az összepontozó kosárból';
      }
      const reason = this.basketReason(item);
      return reason || 'Az összepontozó kosárba';
    },

    // Már pontozott tétel: melyik csatornán (sima = recon_head2, fksz-es = recon_head) és melyik csoportban
    matchedLabel(item) {
      const matched: string[] = [];
      if (Number(item.reconHead2) > 1) matched.push(`sima #${item.reconHead2}`);
      if (Number(item.reconHead) > 1) matched.push(`fksz-es #${item.reconHead}`);
      return matched.length ? `Már pontozva: ${matched.join(', ')}` : '';
    },

    addToBasket(item) {
      if (this.basketReason(item) !== '') {
        return;
      }
      this.basket.add(this.toBasketItem(item));
    },

    // Sor-kiemelés: kosárban lévő tétel zöld (mint a szerkesztő pontozás-pipája), összepontozás-módban
    // a keresett főkönyvi számra illő tétel halvány sárga — így a lenyitott fejben egy pillantással látszik a célpont
    rowRender(h, trElement, defaultSlots, props) {
      const item = props.dataItem;
      let background = '';
      if (this.basket.has(item.id)) {
        background = '#b9ffb9';
      } else if (this.basket.mode.active && this.basket.mode.accno && item.accNo === this.basket.mode.accno) {
        background = '#fff6cc';
      }
      return h('tr', { style: background ? `background-color: ${background}` : '' }, defaultSlots);
    },
  },

  computed: {
    // Normál függvény (nem nyíl), mert a spec.dim oszlopok láthatósága a this.showSpecDims propból jön
    columns(): any[] {
      return [
      {
        filterable: false,
        cell: "detailTemplate"
      },
      {
        field: "id",
        title: "Azonosító"
      },
      {
        field: "prefix",
        title: "Prefix"
      },
      {
        field: "partner",
        title: "Partner neve"
      },
      { field: "accSign",
        title: "Tartozik/követel"
      },
      {
        field: "currTotal",
        title: "Összeg",
        filterable: false,
        cell: "currTotalTemplate"
      },
      {
        field: "accDate",
        title: "Dátum",
        format: "{0: yyyy.MM.dd.}",
        className: "right_text",
        type: ColumnType.Date
      },
      {
        field: "accNo",
        title: "Főkönyvi szám"
      },
      {
        field: "period",
        title: "Periódus"
      },
      {
        field: "bookType",
        title: "Napló"
      },
      { field: "remark",
        title: "Megjegyzés"
      },
      {
        field: "specDim1",
        title: "Munkaszám",
        filterable: false,
        hidden: !this.showSpecDims
      },
      {
        field: "specDim2",
        title: "Gépjármű",
        filterable: false,
        hidden: !this.showSpecDims
      },
      {
        field: "specDim3",
        title: "Szerelő",
        filterable: false,
        hidden: !this.showSpecDims
      },
      {
        field: "specDim4",
        title: "Szerviztípus",
        filterable: false,
        hidden: !this.showSpecDims
      },
      {
        filterable: false,
        width: 0
      }
      ];
    },
  },
})
